import PageWithHeaderLayout from '@/app/layouts/PageWithHeader.layout';

import StationDetailContent from './StationDetailContent';

const StationDetailPage = () => (
	<PageWithHeaderLayout title="주유소 상세" showBackButton>
		<StationDetailContent />
	</PageWithHeaderLayout>
);

export default StationDetailPage;
